import WaitResult from "./WaitResult";

export default [WaitResult];